import React, { useState, useEffect, useRef } from 'react'
// import NotFound from '../../../components/not-found/NotFound'
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded'
// import { toastMessage } from '../../../utils/toastMessage'
import { useSearchParams } from 'react-router-dom'
// import { getConsultantOrderHistoryApi } from '../../../services/consultantManagement'
// import useFullPageLoader from '../../../hooks/useFullPageLoader'
import Pagination from 'react-js-pagination'
import { dateFormatWithTime, formatDuration } from '../../utils/dateFormat'
import NotFound from '../../components/not-found/NotFound'
import IconButton from '../../components/Button/IconButton'
import VisibilityIcon from "@mui/icons-material/Visibility";
import HistoryIcon from "@mui/icons-material/History";
import { addRemedy, fetchAOCList, markUsedForQueryApi, recreateFirstConsultationApi, recreateSecondConsultationApi } from '../../services/userManagement';
import ModalBox from "../../components/modal/ModalBox";
import { FaPlay, FaPause } from 'react-icons/fa';
import { setJwtToken } from '../../config/axiosInstance'
import axios from 'axios'
import { Chathistory } from '../../services/consultantManagement'
import { FREE_COUPON_CODE } from '../../utils/freeCoupon'
import constants from '../../utils/constants'
import { initiateSocketConnection } from '../../utils/common'
import ChatBox from '../../components/chatBox/ChatBox'
import { Modal, Box, Typography, List, ListItem, ListItemText, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material'
import ReplayIcon from '@mui/icons-material/Replay'
import { toastMessage } from '../../utils/toastMessage'
// import { dateFormatWithTime } from '../../../utils/dateFormat'

const _CURRENT_USER = {
  _id: '000000000000000000000000',
  name: 'Vedicmeet Admin',
  profileImage: 'https://vedicmeet.com/statics/vedic-meet_title-logo.webp'
};

const getUniqueConsultationLogs = (logs = []) => {
  const seen = new Set();
  return logs.filter((log) => {
    const key = [
      log.callStatus || '',
      log.callBy || '',
      log.callEndedBy || '',
      log.actionBy || '',
      log.actionValue || '',
      log.cancelledBy || '',
    ].join('|');

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const getConsultationRecordingUrl = (consultation = {}) => (
  consultation?.recordingUrl ||
  consultation?.recording_url ||
  consultation?.callRecordingUrl ||
  consultation?.onCompletion?.recordingUrl ||
  consultation?.onCompletion?.recording_url ||
  consultation?.onCompletion?.callRecordingUrl ||
  consultation?.session_info?.recordingUrl ||
  consultation?.session_info?.recording_url ||
  consultation?.session_info?.callRecordingUrl ||
  consultation?.session_info?.sessionMeta?.recordingUrl ||
  consultation?.session_info?.sessionMeta?.recording_url ||
  ""
);

const UserConsultantListing = ({ handlePageChange, total, activePage, orderList, show, close, listing, username, userId, pageLimit = 10, onRefreshConsultationList }) => {

  let URL = process.env.REACT_APP_API_URL
  const [aocList, setAOCList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [remedyList, setRemedyList] = useState([]);
  const [description, setDescription] = useState('');
  const [input, setInput] = useState({ concern: "" });
  const [attachment, setAttachment] = useState(null);
  const [consultantId, setConsultantId] = useState(null);
  const [consultantRequestFormId, setConsultantRequestFormId] = useState(null);
  const [open, setOpen] = useState(false);
  console.log('orderlistbegin------>', orderList)
  const _socket = useRef(null);
  const [socketConnected, setSocketConnected] = useState(false);
  const [openModalIndex, setOpenModalIndex] = useState(null);
  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [thread, setThread] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [updatedQueryStatusModal, setUpdateQueryStatusModal] = useState(false);
  const [showChatBox, setShowChatBox] = useState(false);
  const [selectedThreadId, setSelectedThreadId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedRecordingUrl, setSelectedRecordingUrl] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [selectedConsultationMode, setSelectedConsultationMode] = useState("");
  const [showLogModal, setShowLogModal] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState([]);

  // Recreate 1st/2nd consultation: confirm dialog
  const [recreateConfirmOpen, setRecreateConfirmOpen] = useState(false);
  const [recreatePendingOrder, setRecreatePendingOrder] = useState(null);
  const [recreateType, setRecreateType] = useState('first'); // 'first' | 'second'
  const [recreateLoading, setRecreateLoading] = useState(false);
  const [queryLoadingId, setQueryLoadingId] = useState(null);

  const openModal = () => setShowModal(true);

  const BASE_URL = "http://localhost:8080";

  // // ✅ Close Modal
  const closeModal = () => {
    setShowModal(false);
    setInputs({
      title: "",
      concern: "",
      remedy: "",
    });
    setDescription("");
    setConsultantRequestFormId(null);
    setConsultantId(null);
    setAttachment(null);
    setRemedyList([]);
    setAOCList([]);
  };


  const [inputs, setInputs] = useState({
    title: "",
    concern: "",
    remedy: "",
  });

  const handleSubmit = async () => {
    closeModal();
    // Find selected concern and remedy labels
    const selectedConcern = aocList.find((item) => item.id === inputs.concern);
    const selectedRemedy = remedyList.find((item) => item.id === inputs.remedy);

    // Define concernLabel and remedyLabel
    const concernLabel = selectedConcern ? selectedConcern.label : "";
    const remedyLabel = selectedRemedy ? selectedRemedy.label : "";

    const _payload = new FormData();
    _payload.append('type', 'AREAOFCONCERN');
    _payload.append('consultantRequestFormId', consultantRequestFormId);
    _payload.append('consultantId', consultantId);
    if (userId) {
      _payload.append('userId', userId);
    }
    _payload.append('title', inputs.title);
    _payload.append('description', description);
    _payload.append('areaOfConcern', concernLabel); // Send concern label instead of ID
    _payload.append('remedy', remedyLabel); // Send remedy label instead of ID
    try {
      const response = await addRemedy(_payload);
      console.log("Remedy added successfully:", response);
    } catch (error) {
      console.error("Error adding remedy:", error);
    }
  };



  const fetchremedy = async () => {
    try {
      const response = await fetchAOCList(); // Fetch from API

      if (!response || !response.data || !response.data.result || !response.data.result.list) {
        console.error("Invalid API response structure", response);
        return;
      }

      // Extract the list from API response
      const list = response.data.result.list.map((element) => ({
        id: element._id,
        label: element.title,
        value: element._id, // Use _id for uniqueness
      }));

      setAOCList(list); // Update state with API data
    } catch (error) {
      console.error("Error fetching remedies:", error);
    }
  };



  useEffect(() => {
    if (inputs.concern) {
      fetchRemedyList();
    }
  }, [inputs.concern]);

  useEffect(() => {
    if (inputs.remedy) {
      fetchDescription();
    }
  }, [inputs.remedy]);


  const fetchRemedyList = async () => {
    try {
      const concernId = inputs.concern; // Get selected concern ID
      if (!concernId) {
        console.error("Concern ID is missing!");
        return;
      }

      const response = await fetchAOCList(concernId); // Call with concernId

      if (!response?.data?.result?.list) {
        console.error("Invalid remedy API response", response);
        return;
      }

      const list = response.data.result.list.map(element => ({
        id: element._id,
        label: element.title,
        value: element.title
      }));

      setRemedyList(list);
    } catch (error) {
      console.error("Error fetching remedy list:", error);
    }
  };

  // fetchRemedyList();


  const fetchDescription = async () => {
    try {

      const concernremedyId = inputs.remedy;
      if (!concernremedyId) {
        console.error("Concern ID is missing!");
        return;
      }
      const response = await fetchAOCList(null, concernremedyId);
      if (!response.data || !response.data.result || !response.data.result.description) {
        console.error("Error: Description field is missing in response");
        return;
      }

      setDescription(response.data.result.description);
    } catch (error) { }
  };

  const handleChange = (e) => {
    setInputs(prevInputs => ({ ...prevInputs, [e.target.name]: e.target.value }));
  };

  // Form Fields
  const fields = [
    { value: "Title*", type: "text", name: "title" },
    { value: null, type: "divider" },
    {
      value: "Area of concern",
      type: "dropdown",
      name: "concern",
      dropdownData: aocList,
    },
    {
      value: "Remedy",
      type: "dropdown",
      name: "remedy",
      dropdownData: remedyList,
    },
    { value: null, type: "divider" },
    {
      value: "Remedy Description",
      type: "text",
      name: "description",
      stateValue: description,
    },
  ];



  const formatDuration = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}m ${seconds}s`;
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'initiated':
        return 'primary';
      case 'started':
        return 'success';
      case 'ended':
        return 'error';
      case 'session_extended':
        return 'warning';
      default:
        return 'default';
    }
  };

  const handleShowLogs = (logs) => {
    const uniqueLogs = getUniqueConsultationLogs(logs);
    if (uniqueLogs && uniqueLogs.length > 0) {
      setSelectedLogs(uniqueLogs);
      setShowLogModal(true);
    } else {
      toastMessage('No logs available for this consultation', 'info');
    }
  };

  const LogModal = ({ open, onClose, logs }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="log-modal-title"
        aria-describedby="log-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          maxHeight: '80vh',
          bgcolor: '#fafafa',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          p: 4,
          overflow: 'auto'
        }}>
          <Typography id="log-modal-title" variant="h6" component="h2" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
            Consultation Logs
          </Typography>
          <Typography id="log-modal-description" variant="body2" color="text.secondary" gutterBottom sx={{ color: '#666' }}>
            Detailed timeline of consultation events
          </Typography>

          <List>
            {logs.map((log, index) => {
              return <ListItem key={index} sx={{
                border: '1px solid #f0f0f0',
                mb: 1,
                borderRadius: 2,
                backgroundColor: '#ffffff',
                '&:hover': {
                  backgroundColor: '#f8f9fa',
                  borderColor: '#e9ecef'
                }
              }}>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip
                        label={log.callStatus}
                        color={getStatusColor(log.callStatus)}
                        size="small"
                        sx={{
                          backgroundColor: getStatusColor(log.callStatus) === 'primary' ? '#e3f2fd' :
                            getStatusColor(log.callStatus) === 'success' ? '#e8f5e8' :
                              getStatusColor(log.callStatus) === 'error' ? '#ffebee' :
                                getStatusColor(log.callStatus) === 'warning' ? '#fff3e0' : '#f5f5f5',
                          color: getStatusColor(log.callStatus) === 'primary' ? '#1976d2' :
                            getStatusColor(log.callStatus) === 'success' ? '#2e7d32' :
                              getStatusColor(log.callStatus) === 'error' ? '#d32f2f' :
                                getStatusColor(log.callStatus) === 'warning' ? '#ed6c02' : '#666'
                        }}
                      />
                      {log.callBy && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.callBy}
                        </Typography>
                      )}
                      {log.callEndedBy && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          ended by {log.callEndedBy}
                        </Typography>
                      )}
                      {log.callStatus == 'missed' ? (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.actionBy == 'both' ? 'Both' : log.actionBy == userId ? 'User' : 'Consultant'}
                        </Typography>
                      ) : log.callStatus == 'cancelled' ? (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.cancelledBy ? log.cancelledBy : log.callBy}
                        </Typography>
                      ) : (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {log.actionBy}
                        </Typography>
                      )}
                      {log.actionValue && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          ({log.actionValue}s)
                        </Typography>
                      )}
                    </Box>
                  }
                  secondary={
                    <Typography variant="body2" sx={{ color: '#888', fontSize: '0.875rem' }}>
                      {formatTimestamp(log.timestamp)}
                    </Typography>
                  }
                />
              </ListItem>
            })}
          </List>

          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton
              onClick={onClose}
              sx={{
                backgroundColor: '#f0f0f0',
                '&:hover': {
                  backgroundColor: '#e0e0e0'
                }
              }}
            >
              Close
            </IconButton>
          </Box>
        </Box>
      </Modal>
    );
  };

  useEffect(() => {
    const socket = initiateSocketConnection({
      uri: `${constants.CHAT_SOCKET_SERVER}/chats`,
      currentUser: _CURRENT_USER,
      onConnect: () => {
        setSocketConnected(true);
      }
    });

    _socket.current = socket;

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    fetchremedy(); // fetch AOC list when component loads
  }, []);

  const handleRecreateClick = (order, type) => {
    setRecreatePendingOrder(order);
    setRecreateType(type);
    setRecreateConfirmOpen(true);
  };

  const handleRecreateConfirm = async () => {
    if (!recreatePendingOrder?._id) return;
    const api = recreateType === 'first' ? recreateFirstConsultationApi : recreateSecondConsultationApi;
    const label = recreateType === 'first' ? '1st' : '2nd';
    try {
      setRecreateLoading(true);
      const { data } = await api({ waitlistId: recreatePendingOrder._id });
      if (data?.code === 200) {
        toastMessage(`${label} consultation recreated successfully. User will get the offer again.`, 'success', 'recreate');
        if (typeof onRefreshConsultationList === 'function') onRefreshConsultationList();
      } else {
        toastMessage(data?.message || `Failed to recreate ${label} consultation`, 'error', 'recreate');
      }
    } catch (err) {
      toastMessage(err?.response?.data?.message || err?.message || `Failed to recreate ${label} consultation`, 'error', 'recreate');
    } finally {
      setRecreateLoading(false);
      setRecreateConfirmOpen(false);
      setRecreatePendingOrder(null);
    }
  };

  const handleRecreateCancel = () => {
    setRecreateConfirmOpen(false);
    setRecreatePendingOrder(null);
  };

  const handleUsedForQueryClick = async (order) => {
    if (!order?._id || order?.used_for !== 'query' || queryLoadingId) return;

    try {
      setQueryLoadingId(order._id);

      const payload = {
        _id: order._id,
        query: order.used_for,
        user_id: order?.user_id?._id || order?.user_id || order?.request_form?.userId || userId,
      };

      const response = await markUsedForQueryApi(payload);

      if (response?.data?.code === 200) {
        toastMessage('Query deleted successfully', 'success');
        if (typeof onRefreshConsultationList === 'function') onRefreshConsultationList();
      } else {
        toastMessage(response?.data?.message || 'Failed to send data', 'error');
      }
    } catch (error) {
      toastMessage(error?.response?.data?.message || error?.message || 'Something went wrong', 'error');
    } finally {
      setQueryLoadingId(null);
    }
  };


  return (
    <>
      {showChatBox && (
        <ChatBox
          threadId={selectedThreadId}
          userName={selectedUserName || username}
          userId={userId}
          onClose={() => {
            setShowChatBox(false);
            setSelectedThreadId(null);
            setSelectedRecordingUrl("");
            setSelectedOrderId("");
            setSelectedConsultationMode("");
          }}
          recordingUrl={selectedRecordingUrl}
          orderId={selectedOrderId}
          consultationMode={selectedConsultationMode}
        />
      )}

      <LogModal
        open={showLogModal}
        onClose={() => setShowLogModal(false)}
        logs={selectedLogs}
      />



      <div className="content-table" style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e9ecef', backgroundColor: '#fff' }}>
        <div style={{ overflow: 'auto', flex: '1 1 0', minHeight: '460px' }}>
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Problem</th>
              <th>Consultant</th>
              <th>Type of Consultation</th>
              <th>Mode of Consultation</th>
              <th>Gender</th>
              <th>Call Start Time</th>
              <th>Call End Time</th>
              <th>Duration</th>
              <th>User Total Consultations</th>
              <th>Consultation</th>
              <th>Chat History</th>
              <th>Log Entries</th>
              <th>Send Remedy</th>
              <th>Date and Time</th>
              <th>Status</th>
              <th>  Reset Query </th>
              <th>Amount</th>
              <th>Recreate 1st / 2nd</th>
            </tr>
          </thead>
          {/* profile: profileImage, name: 'Rahul Chauhan', userId: '123456789',
              PhoneNumber: '1234567890', Email: 'rahul@gmail.com', gender:
              'male', RegistrationDate: '12 Jan 1234', */}
          <tbody>
            {orderList.length > 0 ? (
              orderList.map((order, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{(activePage - 1) * pageLimit + index + 1}</td>
                      <td>{order.request_form?.concern || '---'}</td>
                      <td>{`${order?.consDetails?.accountName}`}</td>
                      <td>{order?.session_info?.mode || '---'}</td>
                      <td>{FREE_COUPON_CODE.includes(order?.coupon?.code) ? 'Free' : 'Paid'}</td>
                      <td>{`${order?.request_form?.gender}`}</td>
                      <td>{dateFormatWithTime(order?.timeLap?.startTime || order?.createdAt) || '---'}</td>
                      <td>{dateFormatWithTime(order?.timeLap?.endTime) || '---'}</td>
                      <td>
                        {order?.timeLap?.startTime && order?.timeLap?.endTime
                          ? formatDuration(
                            new Date(order.timeLap.endTime) - new Date(order.timeLap.startTime)
                          )
                          : '---'}
                      </td>
                      <td>
                        {order?.status?.toLowerCase() === 'completed'
                          ? (order?.userTotalConsultationCount != null ? order.userTotalConsultationCount : '---')
                          : '--'}
                      </td>
                      <td>
                        {order?.status?.toLowerCase() === 'completed'
                          ? (order?.consultationOrderLabel || '---')
                          : '--'}
                      </td>
                      <td>
                        {order?.status === "completed" && (order?.threadId || getConsultationRecordingUrl(order)) ? (
                          <IconButton
                            aria-label="update"
                            className="px-2 py-0"
                          >
                            <VisibilityIcon
                              className="eye_icon"
                              onClick={() => {
                                const recordingUrl = getConsultationRecordingUrl(order);
                                if (!order?.threadId && !recordingUrl) {
                                  console.warn("Thread ID and recording URL are missing in this order:", order);
                                  return;
                                }

                                setSelectedUserName(
                                  `${order?.request_form?.firstName || ''} ${order?.request_form?.lastName || ''}`
                                );
                                setSelectedThreadId(order?.threadId || null);
                                setSelectedRecordingUrl(recordingUrl);
                                setSelectedOrderId(order?.orderId || "");
                                setSelectedConsultationMode(order?.session_info?.mode || "");
                                setShowChatBox(true);
                              }}
                            />
                          </IconButton>
                        ) : (
                          "-----"
                        )}
                      </td>

                      <td>
                        <IconButton
                          aria-label="view-logs"
                          className="px-2 py-0"
                          onClick={() => handleShowLogs(order?.logs)}
                        >
                          <HistoryIcon
                            className="eye_icon"
                            style={{ color: order?.logs && order.logs.length > 0 ? '#ff8989' : '#ccc' }}
                          />
                        </IconButton>
                      </td>


                      <td>
                        <div className="action_button">
                          <IconButton
                            aria-label="update"
                            className="px-2 py-0"
                            onClick={() => {
                              openModal();
                              fetchremedy();
                              setConsultantId(order?.consultant_id);
                              setConsultantRequestFormId(order?._id);
                              // setUserId(order?.user_id );
                              // chat_History(order?.threadId);
                            }}
                          >
                            <VisibilityIcon className="eye_icon" />
                          </IconButton>
                        </div>

                      </td>
                      {/* <td>{order?.refundCreditedAmount?.toFixed(2) || '--'}</td>
                      <td>{order?.refundDebitedAmount?.toFixed(2) || '--'}</td> */}
                      {/* <td>{order?.extendedCallCount || '---'}</td> */}
                      <td>{dateFormatWithTime(order?.createdAt) || '---'}</td>
                      <td>{order?.status || "---"}</td>
                      <td>
                        {order?.used_for === 'query' ? (
                          <Button
                            size="small"
                            variant="text"
                            disabled={queryLoadingId === order?._id}
                            onClick={() => handleUsedForQueryClick(order)}
                            sx={{ minWidth: 0, p: 0, textTransform: 'capitalize', textDecoration: 'underline' }}
                          >
                            {queryLoadingId === order?._id ? 'Sending...' : 'query'}
                          </Button>
                        ) : (
                          order?.used_for || '---'
                        )}
                      </td>
                      <td>{order?.onCompletion?.amountToDeduct !== undefined
                        ? order.onCompletion.amountToDeduct.toFixed(2)
                        : '---'}
                      </td>

                      <td>
                        {order?.status === 'completed' && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                            {order?.coupon?.type === 'first_purchase' && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <IconButton
                                  aria-label="Recreate 1st consultation"
                                  className="px-2 py-0"
                                  onClick={() => handleRecreateClick(order, 'first')}
                                  title="Append _updatedbyadmin to deviceUsedToken so user gets 1st consultation offer again"
                                >
                                  <ReplayIcon style={{ fontSize: '18px', color: '#9c27b0' }} />
                                </IconButton>
                                <span style={{ fontSize: '12px', fontWeight: 500 }}>1st</span>
                                {(order?.recreateFirstConsultationCount > 0) && (
                                  <span style={{ background: '#9c27b0', color: '#fff', borderRadius: '10px', padding: '2px 6px', fontSize: '11px' }}>
                                    {order.recreateFirstConsultationCount}
                                  </span>
                                )}
                              </div>
                            )}
                            {order?.coupon?.type === 'second_purchase' && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <IconButton
                                  aria-label="Recreate 2nd consultation"
                                  className="px-2 py-0"
                                  onClick={() => handleRecreateClick(order, 'second')}
                                  title="Append _updatedbyadmin to deviceUsedToken so user gets 2nd consultation offer again"
                                >
                                  <ReplayIcon style={{ fontSize: '18px', color: '#1976d2' }} />
                                </IconButton>
                                <span style={{ fontSize: '12px', fontWeight: 500 }}>2nd</span>
                                {(order?.recreateSecondConsultationCount > 0) && (
                                  <span style={{ background: '#1976d2', color: '#fff', borderRadius: '10px', padding: '2px 6px', fontSize: '11px' }}>
                                    {order.recreateSecondConsultationCount}
                                  </span>
                                )}
                              </div>
                            )}
                            {order?.coupon?.type !== 'first_purchase' && order?.coupon?.type !== 'second_purchase' && '---'}
                          </div>
                        )}
                        {order?.status !== 'completed' && '---'}
                      </td>

                    </tr>
                  </React.Fragment>
                )
              })
            ) : (
              <NotFound
                cols={6}
                msg="No Order Found!"
                icon={<ViewListRoundedIcon sx={{ fontSize: 48 }} />}
              // loader={loader}
              />
            )}
          </tbody>
        </table>
        </div>
        {total > pageLimit ? (
          <div
            className="pagination-wrapper mt-3 d-flex justify-content-end"
            style={{
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              right: 0,
              padding: '12px 0',
              backgroundColor: '#fff',
              zIndex: 10,
              boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={pageLimit}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        ) : null}
      </div>

      {showModal && <ModalBox
        status={showModal}
        onClose={closeModal}
        title={`Send Remedy to ${username}`}
        size={"sm"}
        closeIcon
        custom
        customizedFooter={
          <div style={{ maxWidth: '650px', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: '440px' }} >
              {fields.map((element, index) => (
                <div key={index}>
                  {element.type === "divider" ? (
                    <hr className="divider" />
                  ) : element.type === "dropdown" ? (
                    <div style={{ gap: '5px' }}>
                      <label style={{ color: 'black' }}>{element.value}</label>
                      <select
                        name={element.name}
                        value={inputs[element.name] || ""}
                        onChange={(e) => handleChange(e)}
                        style={{ borderRadius: '8px', alignSelf: 'center', marginTop: '5px', marginBottom: '5px' }}
                      >
                        <option value="">Select {element.value}</option>
                        {element.dropdownData.map((item) => (
                          <option key={item.id} value={item.id} style={{ borderRadius: '8px', alignSelf: 'center', width: '350px' }}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div>
                      <label style={{ color: 'black' }}>{element.value}</label>
                      {element.name === "description" ? (
                        // ✅ Use <textarea> for description
                        <textarea
                          name={element.name}
                          value={description}
                          onChange={handleChange}
                          placeholder="Enter"
                          disabled
                          style={{
                            height: '100px',
                            width: '100%',
                            resize: 'none',
                            color: 'black', // Change text color
                            fontSize: '16px', // Change font size
                            fontWeight: 'normal', // Optional: Make text bold
                            borderRadius: '8px', // Optional: Rounded corners
                            padding: '10px',
                            borderColor: 'black' // Optional: Add padding inside
                          }}
                        />
                      ) : (
                        // ✅ Use <input> for all other fields (including Title)
                        <input
                          type="text"
                          name={element.name}
                          value={inputs[element.name] || ""}
                          onChange={handleChange}
                          placeholder="Enter"
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}


            </div>
            <button
              onClick={handleSubmit}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "20px",
                backgroundColor: "#FF6666",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                alignSelf: 'center',
              }}
            >
              Send Remedy
            </button>
          </div>

        }
      />}

      <Dialog open={recreateConfirmOpen} onClose={handleRecreateCancel}>
        <DialogTitle>Recreate {recreateType === 'first' ? '1st' : '2nd'} Consultation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to recreate {recreateType === 'first' ? '1st' : '2nd'} consultation for this order?
      
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRecreateCancel} disabled={recreateLoading}>Cancel</Button>
          <Button onClick={handleRecreateConfirm} color="primary" variant="contained" disabled={recreateLoading}>
            {recreateLoading ? 'Updating...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
}
export default UserConsultantListing



